var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBrowseSelected = function SvgBrowseSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#browse-selected_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.35 56.762a5.556 5.556 0 0 1 5.556-5.556h46.667a1.111 1.111 0 1 1 0 2.222H18.906a3.333 3.333 0 0 0-3.333 3.334v2.222a3.333 3.333 0 0 0 3.333 3.333h46.667a1.111 1.111 0 1 1 0 2.222H18.906a5.556 5.556 0 0 1-5.555-5.555v-2.222Z",
    fill: "#C7562E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.128 51.206h-2.222a5.556 5.556 0 0 0-5.555 5.556V22.318a6.667 6.667 0 0 1 6.667-6.668h1.11v35.556Zm38.89-35.556a6.667 6.667 0 0 1 6.666 6.667v30c0-.613-.497-1.11-1.11-1.11H22.238V15.65h37.779Z",
    fill: "url(#browse-selected_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.629 53.428a1.5 1.5 0 0 0-1.5 1.5v5.889a1.5 1.5 0 0 0 1.5 1.5H18.906a3.333 3.333 0 0 1-3.333-3.333v-2.223a3.334 3.334 0 0 1 3.333-3.333h43.723Z",
    fill: "url(#browse-selected_svg__c)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.432 28.503c.139-.253.233-.485.381-.674.145-.184.36-.313.524-.484.402-.421.91-.731 1.263-1.203.136-.18.252-.376.4-.6-.316-.034-.64.078-.804.212a.691.691 0 0 1-.244.116c-.241.07-.484.165-.73.182-.23.016-.512.01-.695-.107-.432-.271-.819-.615-1.223-.93-.6-.469-1.318-.776-1.827-1.37a.539.539 0 0 0-.206-.127c-.254-.103-.51-.2-.767-.297-.066-.024-.138-.058-.204-.053a2.756 2.756 0 0 0-1.655.687c-.42.372-.807.787-1.192 1.199-.497.532-.977 1.08-1.466 1.618-.054.06-.115.144-.183.155-.292.044-.317.312-.438.499-.07.108-.118.232-.183.344-.197.329-.391.661-.6.984-.134.202-.27.409-.444.572-.246.228-.394.183-.513-.138a1.71 1.71 0 0 1-.077-.5c-.011-.278.025-.56-.008-.835-.067-.553-.162-1.105-.255-1.657-.117-.706-.236-1.411-.367-2.115a.634.634 0 0 0-.172-.317c-.25-.24-.492-.504-.785-.676-.36-.209-.767-.333-1.14-.488-.1.123-.164.28-.263.306-.328.091-.67.134-1.005.2-.063.01-.12.039-.181.06l-.824.28c-.011-.026-.095.106-.128.204-.117-.026-.275-.016-.257.01-.189.2-.371.406-.564.601-.112.113-.309.163-.247.391.008.026-.054.08-.092.108-.214.147-.455.264-.636.444-.176.175-.289.414-.431.625-.042.062-.073.153-.133.18-.195.09-.377.17-.305.443.008.029-.02.077-.044.105-.134.163-.303.304-.4.486-.146.269-.386.52-.29.868.023.09.078.21.146.233.074.027.19-.028.27-.077.147-.089.267-.237.422-.295.468-.175.742-.599 1.133-.857.325-.216.737-.296 1.112-.435.016-.005.039.01.058.018.316.095.628.219.95.28.42.08.529.385.572.729.05.417.07.838.087 1.26.015.427.003.856.02 1.284.006.156.079.308.092.466.017.218.008.438.01.656.002.19.014.383.007.573-.007.162-.045.323-.05.485-.017.669-.028 1.338-.038 2.008-.005.27-.014.542 0 .812.022.479.108.953-.02 1.438-.052.2-.032.424-.025.636.005.2.066.402.052.599-.037.502-.098.997-.02 1.506.065.421.053.853.079 1.28.008.157.1.37.028.46-.242.304-.065.645-.128.963-.053.268.103.573.14.865.088.716-.02 1.393-.418 2.01-.269.417-.197.691.153.792.227-.202.42-.369.607-.542.12-.113.208-.29.347-.344.208-.082.304-.214.37-.405a.407.407 0 0 1 .136-.2c.367-.244.727-.495.979-.87.01-.016.035-.023.046-.039.329-.427.722-.824.964-1.296.23-.452.532-.915.475-1.479-.006-.054.066-.114.097-.176.029-.06.087-.137.07-.184-.172-.51.271-.992.064-1.503-.023-.053.011-.149.05-.206.21-.309.09-.602-.024-.903-.11-.296-.281-.588-.045-.912.06-.082.06-.217.061-.327.003-.264-.02-.528-.015-.792.009-.415.187-.841-.09-1.235a.153.153 0 0 1-.02-.09c.047-.59.098-1.181.14-1.773.015-.219-.103-.452.073-.656.006-.007-.007-.039-.018-.056-.218-.371-.295-.676.117-1.028.372-.316.614-.782.94-1.159.244-.282.561-.502.792-.795.32-.407.529-.926 1.082-.939.09-.204.128-.39.237-.51.133-.148.317-.265.5-.346a.654.654 0 0 1 .41-.024c.214.058.426.143.617.254.315.185.627.38.915.602.781.605 1.55 1.226 2.32 1.843.257.206.569.241.833.125.279-.12.498-.371.758-.543.33-.217.604-.569.99-.489",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "browse-selected_svg__b",
    x1: 13.351,
    y1: 42.252,
    x2: 66.684,
    y2: 42.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7241",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#FF7241",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F85C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "browse-selected_svg__c",
    x1: 32.684,
    y1: 53.428,
    x2: 32.684,
    y2: 62.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7241",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7241",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "browse-selected_svg__a",
    x: 11.351,
    y: 14.65,
    width: 57.333,
    height: 52.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6071_2485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6071_2485",
    result: "shape"
  })))));
};
export default SvgBrowseSelected;